import dayjs from 'dayjs'
import { now } from './clock'

// "just now" / "5 min ago" / "3 h ago" / "Yesterday 14:20" / "Mon 4 Nov, 14:20"; needs the i18n mixin (tm) on `vm`
export function relativeTime (vm, value) {
  const t = dayjs(value)
  const current = now()
  const minutes = current.diff(t, 'minute')

  if (minutes < 1) return vm.tm('just_now', 'just now')
  if (minutes < 60) return vm.tm('min_ago', '{n} min ago', { n: minutes })
  if (minutes < 6 * 60) return vm.tm('hours_ago', '{n} h ago', { n: Math.floor(minutes / 60) })
  if (t.isSame(current, 'day')) return t.format('H:mm')
  if (t.isSame(current.subtract(1, 'day'), 'day')) return `${vm.tm('yesterday', 'Yesterday')} ${t.format('H:mm')}`
  return t.format(t.isSame(current, 'year') ? 'ddd D MMM, H:mm' : 'D MMM YYYY')
}
